import { ref } from "vue";
import { topics, getTopicById } from "@/config/topics";

export function useTopics() {
  const allTopics = ref(topics);

  // 根据主题ID获取主题信息
  const getTopicByIdHelper = (id) => {
    return getTopicById(id);
  };

  return {
    topics: allTopics,
    getTopicById: getTopicByIdHelper,
  };
}
